import React from 'react';
import AdvisoryProps from '../interfaces/AdvisoryProps';

const AdvisoryNpm: React.FC<AdvisoryProps> = ({ packageName, advisory }) => {

    return (
        <div>
            <h4>{packageName}</h4>
            <ul>
                <li>Title : {advisory.title}</li>
                <li>CVE : {advisory.cves.join(";")}</li>
                <li>Severity : {advisory.severity}</li>
                <li>Affected Versions : {advisory.vulnerable_versions}</li>
                <li>Link : <a href={advisory.url} target="_blank" rel="noreferrer">{advisory.url}</a></li>
            </ul>
        </div>
    );
}

export default AdvisoryNpm;